import { useCoreQuery } from '~/hooks/useCoreQuery'

/**
 * Query list of pages
 */
export const usePages = () => {
  const { error, fetching, data } = useCoreQuery()
  return { error, fetching, pages: data?.pages }
}
